export const WealthHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Sync client profiles between Zocks and Wealth.com</li>
        <li>Prepare for meetings using Wealth.com estate planning details inside Zocks</li>
        <li>Get instant answers about estate plans with Ask Anything, powered by Wealth.com data</li>
        <li>Draft email replies using real estate planning context from Wealth.com</li>
        <li>Use estate planning data across Zocks workflows (Ask Anything, Email Replies, Meeting Prep)</li>
      </ul>
    </div>
  )
}
